import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import { faCaretDown, faFilter} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


interface Props {
  options: string[];
  filters: string[];
  onChange?: (newFilters: string[]) => void;
  menuDisplay: boolean;
}

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-block',
    marginBottom: theme.spacing(0.5),
    "& button": {
      padding: theme.spacing(1, 0.75),
      textAlign: 'center',
      borderStyle: 'solid',
      borderWidth: 1,
      fontSize: 12,
      margin: 1,
    },
    "& button:hover": {
      cursor: 'pointer',
      borderColor: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light,
      color: theme.palette.primary.contrastText,
    },
    "& .mobileDisplay": {
      "@media(min-width:700px)":{
        display:"none"
      },
    },
    "& .standardDisplay": {
      "@media(max-width:700px)":{
        display:"none"
      },
    },

  },
  on: {
    borderColor: theme.palette.primary.main,
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.contrastText,
    '&:hover':{
      backgroundColor: theme.palette.primary.main,
    },
  },
  off: {
    borderColor: "#ccc",
    backgroundColor: "#fff",
    color: "#999",
  },
}));

export const FilterGroup:React.FC<Props> = (props)=> {
  const { options, filters, onChange, menuDisplay } =  props
  const [state, setState] = React.useState<{[option:string]:boolean}>({});
  const classes = useStyles();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(()=>{
    const newState:{[team:string]:boolean} = {};
    options.forEach((option) => {
      newState[option] = filters.includes(option);
    });
    setState(newState);

  },[options]);

  const toggle = (team:string) => {
    const newState = {...state, [team]:!state[team]};
    const filters:string[] = [];
    setState(newState);
    if (onChange) {
      Object.entries(newState).forEach(([option, toggle]) => {
        if (toggle) {
          filters.push(option);
        }
      });
      onChange(filters);
    }
  };
   
return (
  <div className={classes.root}>
      <div className="mobileDisplay">
      <button
      id="basic-button"
      aria-controls={open ? "basic-menu" : undefined}
      aria-haspopup="true"
      aria-expanded={open ? "true" : undefined}
      className={Object.values(state).includes(true) ? classes.on : classes.off}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={faFilter} />
      &nbsp;Filters&nbsp;  
    <FontAwesomeIcon icon={faCaretDown} />
    </button>
      <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      getContentAnchorEl={null}
    >
        {options.map((option) =>
        <MenuItem
        key={option}
        className={state[option] ? classes.on : classes.off}
        onClick={()=>{toggle(option);handleClose()}}
      >
          {option}   
      </MenuItem>
      )}

    </Menu>
      </div>
      <div className="standardDisplay">
      {menuDisplay ? (
    <button
      id="basic-button"
      aria-controls={open ? "basic-menu" : undefined}
      aria-haspopup="true"
      aria-expanded={open ? "true" : undefined}
      className={Object.values(state).includes(true) ? classes.on : classes.off}
      onClick={handleClick}
    >
      <FontAwesomeIcon icon={faFilter} />
      &nbsp;Filters&nbsp;
      <FontAwesomeIcon icon={faCaretDown} />
    </button>
  ) : (
    options.map((option) => (
      <button
        key={option}
        value={option}
        className={state[option] ? classes.on : classes.off}
        onClick={() => toggle(option)}
      >
        {option}
      </button>
    ))
  )}
  {menuDisplay && (
    <Menu
      id="basic-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      MenuListProps={{
        "aria-labelledby": "basic-button",
      }}
      anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      getContentAnchorEl={null}
    >
      {options.map((option) => (
        <MenuItem
          key={option}
          className={state[option] ? classes.on : classes.off}
          onClick={() => {
            toggle(option);
          }}
        >
          {option}
        </MenuItem>
      ))}
    </Menu>
  )}
      </div>
  </div>
);
  


};

